import { getRandomId } from "../id";
import { sortItem } from "../utils";
export class ArrowTool {
    constructor(sketch, options = {}) {
        this.sketch = sketch;
        this.options = options;
        this.wasDown = false;
        this.onDrawn = null;
        this.sketch.scope.activate();
        this.options = Object.assign({ headLength: 24, headAngle: 140 }, this.options);
        this.tool = new this.sketch.scope.Tool();
        this.tool.minDistance = 3;
        this.tool.onMouseDown = (ev) => this.onMouseDown(ev);
        this.tool.onMouseDrag = (ev) => this.onMouseDrag(ev);
        this.tool.onMouseUp = (ev) => this.onMouseUp(ev);
        this.tool.onKeyUp = (ev) => this.onKeyUp(ev);
    }
    enable() {
        this.tool.activate();
    }
    disable() {
        this.sketch.noTool.activate();
    }
    draw(data) {
        this.sketch.scope.activate();
        const group = new this.sketch.scope.Group();
        group.importJSON(data);
        sortItem(group);
    }
    onMouseDown(ev) {
        this.wasDown = true;
    }
    onMouseDrag(ev) {
        var _a;
        if (!this.wasDown) {
            return;
        }
        (_a = this.arrow) === null || _a === void 0 ? void 0 : _a.remove();
        const start = ev.downPoint;
        const end = ev.point;
        const tailVector = end.subtract(start);
        const headLine = tailVector.normalize(this.options.headLength);
        this.arrow = new this.sketch.scope.Group([
            new this.sketch.scope.Path([start, end]),
            new this.sketch.scope.Path([
                // @ts-ignore
                end.add(headLine.rotate(this.options.headAngle)),
                end,
                // @ts-ignore
                end.add(headLine.rotate(-this.options.headAngle)),
            ]),
        ]);
        this.arrow.set(Object.assign({ strokeColor: "#36f", strokeWidth: 6, strokeJoin: "round", strokeCap: "round", shadowColor: "black" }, this.options));
    }
    onMouseUp(ev) {
        if (this.onDrawn && this.arrow) {
            this.arrow.data = {
                tool: "arrow",
                id: getRandomId(),
                userId: this.sketch.userId,
                userEndpointId: this.sketch.userEndpointId,
            };
            this.onDrawn(this.arrow.exportJSON({ asString: false }));
        }
        this.arrow = null;
    }
    onKeyUp(ev) {
        this.sketch.scope.activate();
        if (ev.key === "escape" && this.arrow) {
            this.arrow.remove();
            this.arrow = null;
            this.wasDown = false;
        }
    }
}
